import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';
import { urlFor, client } from '../../client';
import { useLanguage } from '../../context/LanguageContext';

const About = () => {
  const [abouts, setAbouts] = useState([]);
  const { t, language } = useLanguage();

  useEffect(() => {
    const query = `*[_type == "abouts"]${language === 'fr' ? '_lang_fr' : ''}`;

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, [language]);

  return (
    <>
      <h2 className="head-text">{t.about.title_1}<span>{t.about.title_2}</span> <br />{t.about.title_3}<span>{t.about.title_4}</span></h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);
